import { micromodal } from "javascripts/micromodal";

document.addEventListener("DOMContentLoaded", () => {
  const micromodalTrigger = "data-micromodal-trigger";
  const links = document.querySelectorAll(`[${micromodalTrigger}]`);
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const id = link.getAttribute(micromodalTrigger);
      micromodal(id);
    });
  });
});
